// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MenuItensStatus_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/menu_itens_status/delete/{id}
 *
 * Confirms deletion of a menu item status.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MenuItensStatus_DeleteResponseDados {
message: string
}

export type MenuItensStatus_DeleteResponse = ApiResponse<MenuItensStatus_DeleteResponseDados>;

registerResponseContract('MenuItensStatus_DeleteResponse', {
  message: { type: 'string',  required: true },
})
